/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	01-03-2018
	- [ADDED] Added document.ready to onready.
	26-02-2018
	- [ADDED] Open en Close methods are extended with new function to prevent body scrolling when menu is open
2017
	30-11-2017
	- [CHANGE] .js-menu-button is now changed to .js-mobile-menu-button
	15-10-2017
	- [METHOD] Add and remove .active class to the js-menu-button.
	30-08-2017
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/

var specific_logo = {};

(function () {

	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	// none

	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************

	this.onready = function () {

		/*
		Init: Project
		*/
		var _project = $('.page').data('project');

		$('.js-client').html('').fadeOut(0);
		$('.js-logo').find('.text').fadeOut(0);

		if (
			typeof _project != 'undefined' &&
			_project != ''
		) {

			$('.js-logo').find('.text').fadeIn();
			$('.js-client').html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>' + _project).fadeIn(200);

		} else {

			// $('.js-logo').find('.icon').fadeIn();

		}

		/*
		Icon: Show or hide?
		*/
		if (
			url[2] == '' ||
			url[2] != 'werk' &&
			url[2] != 'showcase'
		) {

			$('.js-logo').find('.icon').removeClass('gone').addClass('show');
			$('.js-slogan').show();

		} else {

			if (
				url[2] == 'werk' &&
				url[3] == '' ||
				url[2] == 'werk' &&
				url[3] == 'projecttype' ||
				url[2] == 'werk' &&
				url[3] == 'expertise'
			) {

				$('.js-logo').find('.icon').removeClass('gone').addClass('show');
				$('.js-slogan').show();

			} else {

				if (
					url[2] == 'showcase'
				) {

					$('.js-slogan').stop().fadeOut(500);

				} else {

					$('.js-logo').find('.icon').removeClass('show').addClass('gone');
					$('.js-slogan').hide();

				}

			}
		}

	};

}).apply(specific_logo); 